import i18n from 'i18n';

import img1 from './img/1@2x.png';
import img2 from './img/2@2x.png';
import img3 from './img/3@2x.png';
import img4 from './img/4@2x.png';
import img5 from './img/5@2x.png';
import { AboutSectionProps } from './section';

export const SECTIONS_CONTENT: AboutSectionProps[] = [
  {
    title: i18n.t('main.about.aiResume.title', { ns: 'careerHub' }),
    subtitle: i18n.t('main.about.aiResume.subtitle', { ns: 'careerHub' }),
    text: i18n.t('main.about.aiResume.text', { ns: 'careerHub' }),
    img: img1,
    isReversed: true,
    bullets: [
      i18n.t('main.about.aiResume.bullet1', { ns: 'careerHub' }),
      i18n.t('main.about.aiResume.bullet2', { ns: 'careerHub' }),
      i18n.t('main.about.aiResume.bullet3', { ns: 'careerHub' }),
    ],
  },
  {
    title: i18n.t('main.about.aiCoverLetter.title', { ns: 'careerHub' }),
    subtitle: i18n.t('main.about.aiCoverLetter.subtitle', { ns: 'careerHub' }),
    text: i18n.t('main.about.aiCoverLetter.text', { ns: 'careerHub' }),
    img: img2,
    bullets: [
      i18n.t('main.about.aiCoverLetter.bullet1', { ns: 'careerHub' }),
      i18n.t('main.about.aiCoverLetter.bullet2', { ns: 'careerHub' }),
      i18n.t('main.about.aiCoverLetter.bullet3', { ns: 'careerHub' }),
    ],
  },
  {
    title: i18n.t('main.about.aiInterview.title', { ns: 'careerHub' }),
    subtitle: i18n.t('main.about.aiInterview.subtitle', { ns: 'careerHub' }),
    text: i18n.t('main.about.aiInterview.text', { ns: 'careerHub' }),
    img: img3,
    isReversed: true,
    bullets: [
      i18n.t('main.about.aiInterview.bullet1', { ns: 'careerHub' }),
      i18n.t('main.about.aiInterview.bullet2', { ns: 'careerHub' }),
      i18n.t('main.about.aiInterview.bullet3', { ns: 'careerHub' }),
    ],
  },
  {
    title: i18n.t('main.about.contactTracker.title', { ns: 'careerHub' }),
    subtitle: i18n.t('main.about.contactTracker.subtitle', { ns: 'careerHub' }),
    text: i18n.t('main.about.contactTracker.text', { ns: 'careerHub' }),
    img: img4,
    bullets: [
      i18n.t('main.about.contactTracker.bullet1', { ns: 'careerHub' }),
      i18n.t('main.about.contactTracker.bullet2', { ns: 'careerHub' }),
      i18n.t('main.about.contactTracker.bullet3', { ns: 'careerHub' }),
    ],
  },
  {
    title: i18n.t('main.about.jobTracker.title', { ns: 'careerHub' }),
    subtitle: i18n.t('main.about.jobTracker.subtitle', { ns: 'careerHub' }),
    text: i18n.t('main.about.jobTracker.text', { ns: 'careerHub' }),
    img: img5,
    isReversed: true,
    bullets: [
      i18n.t('main.about.jobTracker.bullet1', { ns: 'careerHub' }),
      i18n.t('main.about.jobTracker.bullet2', { ns: 'careerHub' }),
      i18n.t('main.about.jobTracker.bullet3', { ns: 'careerHub' }),
    ],
  },
  {
    title: i18n.t('main.about.salaryNegotiation.title', { ns: 'careerHub' }),
    subtitle: i18n.t('main.about.salaryNegotiation.subtitle', {
      ns: 'careerHub',
    }),
    text: i18n.t('main.about.salaryNegotiation.text', { ns: 'careerHub' }),
    img: img1,
    bullets: [
      i18n.t('main.about.salaryNegotiation.bullet1', { ns: 'careerHub' }),
      i18n.t('main.about.salaryNegotiation.bullet2', { ns: 'careerHub' }),
      i18n.t('main.about.salaryNegotiation.bullet3', { ns: 'careerHub' }),
    ],
  },
];
